import React from 'react';
import Button from '@mui/material/Button';

import { useStyles, useStylesRegularPrimary } from './styles';

function PrimaryButton({
  handleClick,
  text,
  isDisabledButton,
  isLoading,
  classesButton,
  endIcon,
  startIcon,
  customStyle,
}) {
  const classes = useStyles();
  const classesRegularPrimary = useStylesRegularPrimary();
  return isLoading ? (
    <Button
      disabled={isDisabledButton}
      fullWidth
      onClick={handleClick}
      className={classes.button}
      classes={classesButton ? classesButton : classesRegularPrimary}
      sx={customStyle}
    >
      {text}
    </Button>
  ) : (
    <Button
      disabled={isDisabledButton}
      onClick={handleClick}
      className={classes.button}
      startIcon={startIcon}
      endIcon={endIcon}
      classes={classesButton ? classesButton : classesRegularPrimary}
      sx={customStyle}
    >
      {text}
    </Button>
  );
}

export default PrimaryButton;
